var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxaClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1. Interface icons/1. Common actions/close_AXA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6731 14.3875L15.5875 14.3119L15.4952 14.2488C15.1462 14.0409 14.6879 14.0871 14.3875 14.3875C14.0325 14.7425 14.0325 15.3181 14.3875 15.6731L20.4481 21.7337L20.5337 21.8094C20.8904 22.0867 21.406 22.0614 21.7337 21.7337C22.0888 21.3787 22.0888 20.8031 21.7337 20.4481L15.6731 14.3875ZM3.55192 2.26627L3.46627 2.19064L3.374 2.12762C3.025 1.91965 2.56667 1.96586 2.26627 2.26627C1.91124 2.62129 1.91124 3.19689 2.26627 3.55192L8.32687 9.61252L8.41252 9.68815C8.76914 9.96544 9.28481 9.94023 9.61252 9.61252C9.96754 9.2575 9.96754 8.68189 9.61252 8.32687L3.55192 2.26627ZM21.7337 2.26627C21.3787 1.91124 20.8031 1.91124 20.4481 2.26627L2.26627 20.4481L2.19064 20.5337C1.91335 20.8904 1.93855 21.406 2.26627 21.7337C2.62129 22.0888 3.19689 22.0888 3.55192 21.7337L21.7337 3.55192L21.8094 3.46627C22.0867 3.10964 22.0614 2.59398 21.7337 2.26627Z",
    fill: "#00008F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxaClose);
export default __webpack_public_path__ + "static/media/axa_close.68ae17fa15ff82b1e95960bcb85bda81.svg";
export { ForwardRef as ReactComponent };